export enum DocumentType {
    PrivacyPolicy = 'privacy-policy',
    TermsAndCondition = 'terms-and-conditions',
    RefundPolicy = 'refund-policy'
}
